import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const HrbsPage = lazy(() => import('@/pages/settings/hrbs'));

export const hrbsRoutes: RouteConfig = {
  path: '/settings/hrbs',
  layout: DashboardLayout,
  element: HrbsPage,
};
